module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarX-10@2x.58107e87.png";